var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconexport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00195 3C9.41617 3 9.75195 3.33579 9.75195 3.75V4.25C9.75195 4.66421 9.41617 5 9.00195 5H7L6.7959 5.01074C5.78722 5.113 5 5.96435 5 7V16C5 17.1046 5.89543 18 7 18H16C17.1046 18 18 17.1046 18 16V13.7217C18 13.3075 18.3358 12.9717 18.75 12.9717H19.25C19.6642 12.9717 20 13.3075 20 13.7217V16C20 18.2091 18.2091 20 16 20H7C4.79086 20 3 18.2091 3 16V7C3 4.85996 4.68056 3.11211 6.79395 3.00488L7 3H9.00195ZM18.6893 3C18.8883 3 19.079 3.07902 19.2197 3.21967L19.7803 3.78033C19.921 3.92098 20 4.11175 20 4.31066V10.3213C20 10.7355 19.6642 11.0713 19.25 11.0713H18.75C18.3358 11.0713 18 10.7355 18 10.3213V8.21203C18 7.54385 17.1921 7.20922 16.7197 7.6817L13.2315 11.1699C12.9386 11.4628 12.4637 11.4628 12.1708 11.1699L11.8174 10.8165C11.5245 10.5236 11.5245 10.0487 11.8174 9.7558L15.2929 6.28033C15.7654 5.80786 15.4308 5 14.7626 5H12.6787C12.2645 5 11.9287 4.66421 11.9287 4.25V3.75C11.9287 3.33579 12.2645 3 12.6787 3H18.6893Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconexport);
export default __webpack_public_path__ + "static/media/icon.export.f8a93d5dfd2da07ccb2488ce4b14c083.svg";
export { ForwardRef as ReactComponent };